let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("egrVC"), load("gvaCb")]).then(() => parcelRequire('fILuR'));